export interface IstopWatch {
    start: () => void;
    stop: () => void;
    elapsed: () => number;
}

export class StopWatch implements IstopWatch {
    private _start: number;
    private _interval: number;

    start() {
        this._start = Date.now();
    }

    stop() {
        const stop = Date.now();
        this._interval = stop - this._start;
    }

    elapsed() {
        return this._interval;
    }
}